export default __webpack_public_path__ + "static/media/element_71.d489d140.webp";